import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { STATUS } from "../../utils/const"
import { RootState } from "../store"
import BaseApi from "../../api/api"

export type WbReportState = {
  shop: string
  dateFrom: string
  dateTo: string
  status: STATUS
  isDaily?: boolean
  errors?: { message: string; [key: string]: any }
}

type initialStateType = {
  wb: {
    reports: WbReportState[]
  }
}

const initialState: initialStateType = {
  wb: {
    reports: [],
  },
}

const reportsSlice = createSlice({
  name: "reportState",
  initialState,
  reducers: {
    setReportState: (state, action: PayloadAction<initialStateType>) => {
      state.wb = action.payload.wb
    },
  },
})

export const updateReportState = createAsyncThunk(
  "reportState/update",
  async (_, { dispatch }) => {
    const response = await BaseApi.reportsState()
    dispatch(setReportState(response.data))
    return response.data
  },
)

export const selectWbReports = (state: RootState) =>
  state.reportState.wb.reports

export default reportsSlice.reducer

export const { setReportState } = reportsSlice.actions
